export const MODIFY_NOTEBOOK = "MODIFY_NOTEBOOK";
export const MODIFY_CWC = "MODIFY_CWC";
export const MODIFY_CELL_EXECUTION_DETAILS = "MODIFY_CELL_EXECUTION_DETAILS";
export const RESET_STATE = "RESET_STATE"
export const UPDATE_STATE = "UPDATE_STATE"
export const MODIFY_RUNNING_CODE_OUTPUT = "MODIFY_RUNNING_CODE_OUTPUT"
export const MODIFY_CODE_CELL = "MODIFY_CODE_CELL"
export const MODIFY_CHAT_HISTORY_CELL = "MODIFY_CHAT_HISTORY_CELL"
export const NotebookReducer = (state, action) => {
    const tempState = { ...state };
    const cellIndex = action.payload.cellIndex;
    switch (action.type) {
        case UPDATE_STATE:
            return action.payload
        case RESET_STATE:
            return action.payload;
        case MODIFY_NOTEBOOK:
            if (!state.notebook) {
                throw new Error("State Does not have Notebook");
            }
            return {
                ...state,
                notebook: {
                    ...state.notebook,
                }
            };
        case MODIFY_CELL_EXECUTION_DETAILS:
            console.log("Setting Execution details ", cellIndex)
            // console.log("payload ", action.payload)
            if (!state.cellExecutionDetails) {
                throw new Error("State Does not have Cell Execution Deatils");
            }
            if (action.payload.stopAllCells) {
                tempState.cellExecutionDetails = tempState.cellExecutionDetails.map(cellDetail => {
                    return {
                        ...cellDetail,
                        isExecuting: false
                    }
                })
                return tempState;
            }
            if (action.payload.isExecuting) {
                tempState.cellExecutionDetails[cellIndex] = {
                    ...tempState.cellExecutionDetails[cellIndex],
                    isExecuting: action.payload.isExecuting === "true",
                }
            }
            if (action.payload.executionCount !== null) {
                tempState.cellExecutionDetails[cellIndex] = {
                    ...tempState.cellExecutionDetails[cellIndex],
                    executionCount: action.payload.executionCount,
                }
            }
            return tempState;

        case MODIFY_RUNNING_CODE_OUTPUT:
            const output = action.payload.output;
            console.log("Setting output ", action.payload.cellIndex);
            // console.log(output)
            if (tempState?.notebook?.cells[action.payload.cellIndex]) {
                tempState.notebook.cells[action.payload.cellIndex] = {
                    ...tempState.notebook.cells[action.payload.cellIndex],
                    outputs: output,
                }
                return tempState;
            }
            return state;
        case MODIFY_CODE_CELL:
            const code = action.payload.code;
            console.log("Setting code ", action.payload.cellIndex);
            // console.log(code)
            if (tempState?.notebook?.cells[cellIndex]) {
                tempState.notebook.cells[cellIndex] = {
                    ...tempState.notebook.cells[cellIndex],
                    source: code,
                }
                if (action.payload.modifyCwcContext) {
                    tempState.cwc = modifyChatContext(tempState.cwc, cellIndex, code.join(""));
                }
                return tempState;
            }
            return state;
        case MODIFY_CHAT_HISTORY_CELL:
            const cellHistory = action.payload.cellChatHistory;
            if (tempState?.cwc[cellIndex]) {
                tempState.cwc[cellIndex] = cellHistory;
            }
            return tempState

        default:
            throw new Error(`Unknown action type: ${action.type}`);
    }
}


const modifyChatContext = (prevChatHistory, cellIndex, newContext) => {
    const updatedChatHistory = [...prevChatHistory]; // Shallow copy
    if (updatedChatHistory[cellIndex]) {
        const lastchat = updatedChatHistory[cellIndex]?.chat?.pop();
        if (lastchat && lastchat.isCode && lastchat.message !== newContext) {
            if (lastchat.type === "outgoing") {
                updatedChatHistory[cellIndex].chat.push({ type: "outgoing", isCode: true, message: newContext });
            } else {
                updatedChatHistory[cellIndex].chat.push(lastchat);
                updatedChatHistory[cellIndex].chat.push({ type: "outgoing", isCode: true, message: newContext });
            }
        } else updatedChatHistory[cellIndex].chat.push(lastchat);

        // update debug
        const lastdebugchat = updatedChatHistory[cellIndex]?.debug?.pop();
        if (lastdebugchat && lastdebugchat.message !== newContext) {
            if (lastdebugchat.type === "outgoing") {
                updatedChatHistory[cellIndex].debug.push({ type: "outgoing", isCode: true, message: newContext });
            } else {
                updatedChatHistory[cellIndex].debug.push(lastdebugchat);
                updatedChatHistory[cellIndex].debug.push({ type: "outgoing", isCode: true, message: newContext });
            }
        } else updatedChatHistory[cellIndex].debug.push(lastdebugchat);
    }
    return updatedChatHistory;
};